// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kPSC","toggle":"styles_toggle__3KCLT","preview":"styles_preview__2Z56j"};